import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';

export default function ProgressBar({size,color,page=null}) {
  return (
      <CircularProgress size={size} color={color} className={page!==null?'text-success progress-bar':""}/>
  );
}